import axios from 'axios';
import type { TServiceBatch } from '../../../types/TServiceBatch';

export type TFindOneServiceBatch = {
  serviceBatchId: string;
  isFetching?: React.Dispatch<React.SetStateAction<boolean>>;
  userAccessToken: string;
};

type TSuccessResponse = {
  status: 'SUCCESS',
  data: TServiceBatch;
};

type TErrorResponse = {
  status: 'ERROR',
  data: any;
};

export const findOneServiceBatch = async ({
  serviceBatchId,
  isFetching,
  userAccessToken,
}: TFindOneServiceBatch): Promise<TSuccessResponse | TErrorResponse> => {
  try {
    if (isFetching) isFetching(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/service-batch/${serviceBatchId}`,
      {
        headers: {
          Authorization: `Bearer ${userAccessToken}`,
        },
      }
    );
    return {
      status: 'SUCCESS',
      data,
    };
  } catch (err: any) {
    return {
      status: 'ERROR',
      data: err.response,
    };
  } finally {
    if (isFetching) isFetching(false);
  }
};
